import React, { Component } from "react";
import Chart from "react-apexcharts";
import moment from "moment";

export default class LineGraph extends Component {
  render() {
    const { sensor, kleur } = this.props;
    
    function prepareApexData(data) {
      if (!data || !data.data || !Array.isArray(data.data)) {
        return {
          categories: [],
          currentPeriod: [],
          previousPeriod: []
        };
      }

      const categories = [];
      const currentPeriod = [];
      const previousPeriod = [];

      data.data.forEach(function (a, key) {
        if (a.datum && a.total !== undefined) {
          const timestamp = new Date(a.datum).getTime();
          const currentValue = parseFloat((((a.total / 1000) * 690) / 1000).toFixed(2));
          
          categories.push(timestamp);
          currentPeriod.push(currentValue);
          
          if (data.vorigeperoide && data.vorigeperoide[key] && data.vorigeperoide[key].total !== undefined) {
            const previousValue = parseFloat((((data.vorigeperoide[key].total / 1000) * 690) / 1000).toFixed(2));
            previousPeriod.push(previousValue);
          } else {
            previousPeriod.push(null);
          }
        }
      });

      return { categories, currentPeriod, previousPeriod };
    }

    const chartData = prepareApexData(sensor || {});
    
    const series = [
      {
        name: "Huidige Periode",
        data: chartData.currentPeriod
      },
      {
        name: "Vorige Periode",
        data: chartData.previousPeriod
      }
    ];

    const options = {
      chart: {
        type: 'line',
        height: 300,
        zoom: {
          enabled: true
        },
        toolbar: {
          show: true
        }
      },
      colors: [kleur || '#D96A29', '#999999'],
      stroke: {
        curve: 'smooth',
        width: [2, 2],
        dashArray: [0, 5]
      },
      xaxis: {
        type: 'datetime',
        categories: chartData.categories,
        labels: {
          format: 'dd MMM HH:mm'
        },
        title: {
          text: 'Datum'
        }
      },
      yaxis: {
        title: {
          text: 'kWh'
        },
        labels: {
          formatter: function (val) {
            return val ? val.toFixed(2) : '0.00';
          }
        }
      },
      tooltip: {
        x: {
          format: 'dd MMM yyyy HH:mm'
        },
        y: {
          formatter: function (val) {
            return val ? val.toFixed(2) + ' kWh' : '0.00 kWh';
          }
        }
      },
      legend: {
        position: 'top'
      },
      grid: {
        borderColor: '#e7e7e7',
        strokeDashArray: 3
      }
    };

    return (
      <div style={{ width: '100%', height: '300px' }}>
        {chartData.categories.length > 0 ? (
          <Chart
            options={options}
            series={series}
            type="line"
            height={300}
          />
        ) : (
          <div style={{ 
            height: '300px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: '#666'
          }}>
            Loading Chart...
          </div>
        )}
      </div>
    );
  }
}
